import React, {Fragment} from 'react'
import Icon from "../Icon";
import {ElasticScaleInOut} from "../transitions/ElasticScaleInOut";
import {Transition} from "@headlessui/react";
import {concatenate} from "../../services/string";

// Types ----

type CardProps = {
  heading: string
  subheading?: string | null
  footer?: string | null
  imageUrl?: string
  onClick: () => void
  active?: boolean
  disabled?: boolean
}

// Component ----

function Card({heading, subheading, footer, imageUrl, onClick, active = false, disabled = false}: CardProps) {
  const baseClasses = 'flex gap-4 border border-gray-200 min-h-[4.5rem] rounded-md items-center overflow-hidden text-left flex-shrink-0';
  const disabledClasses = disabled ? 'cursor-not-allowed opacity-70' : 'hover:border-gray-300';

  return (
    <Transition
      as={Fragment}
      appear={true}
      enter="transition-[opacity] duration-500 transform-gpu"
      enterFrom="opacity-0"
      enterTo="opacity-100"
    >
      <button
        onClick={onClick}
        className={concatenate(baseClasses, disabledClasses)}
        disabled={disabled}
      >
        <div
          className='self-stretch w-[60px] sm:w-[100px] bg-gray-100 overflow-hidden flex-shrink-0 bg-cover bg-no-repeat'
          style={{backgroundImage: `url(${imageUrl})`}}
        />

        <div className="flex flex-col min-w-0 gap-1.5 py-2">
          <p className="text-sm text-gray-900 truncate">{heading}</p>
          {subheading && <p className="text-sm text-gray-500 truncate">{subheading}</p>}
          {footer && <p className="text-xs text-gray-400 truncate tracking-wider">{footer}</p>}
        </div>

        <div className="flex ml-auto shrink-0 pr-4 items-center">
          <ElasticScaleInOut enabled={active}>
            <div className='bg-green-600 rounded-full p-0.5'>
              <Icon name='check' className='text-white size-4' />
            </div>
          </ElasticScaleInOut>

          {disabled &&
              <Icon name='ban' className='text-gray-400 size-5' />
          }
        </div>
      </button>
    </Transition>
  );
}

export {Card};